import axios from 'axios';
import {getApiConfig} from '../config/configProvider';
import {GQL_SUBMIT_REVIEW} from '../gql/reviews.gql';

export default class ReviewsApi {
  static submitReview(variables, headers) {
    const config = getApiConfig();
    return axios({
      url: config.graphQL,
      method: 'post',
      data: {
        query: GQL_SUBMIT_REVIEW,
        variables,
      },
      headers,
    }).then(res => res.data);
  }
}
